import { useState } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { getChatList, userMyMembershipCardDetails } from "../../Services/api";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MembershipCard from "../../Components/MembershipCard/MembershipCard";
import axiosInstance from "../../Services/axios";
import { BsThreeDots } from "react-icons/bs";
import Lottie from "lottie-react";
import empotyLottie from "../../Assets/lottieFiles/emptybox.json"
import { showToast } from "../../Components/toastConfig/ToastConfig";
import NodeaxiosInstance from "../../Services/nodeaxios";
import Kitchen_ticket from "../../Components/kichen_tickct/kitchen_ticket";
import Kitchen_membership_card from "../../Components/KitchenMembershipCard/Kitchen_membership_card";
import { useSelector } from "react-redux";
const UserMembership = () => {
  const location = useLocation()
  const { fromPage } = location.state || {};
  const state = useSelector((state) => state);
  const [userData, serUserData] = useState(state?.userAuth?.user);

  const [myMembership, setMyMembership] = useState([]);
  const [selectedCard, setSelectedCard] = useState({
    vendorID: null,
    membershipID: null,
    PurchaseID: null,
  });
  const [myFoodMembership, setMyFoodMembership] = useState([]);
  const [pageLoading, setPageLoading] = useState(false)
  const [pageLoaded, setPageLoaded] = useState(false);
  const [data, setData] = useState([])

  const navigate = useNavigate();
  const getMyMembership = async () => {
    try {
      setPageLoading(false);
      const res = await userMyMembershipCardDetails();
      setMyMembership(res.data?.user_memberships_details || []);
      fetch_ticket_deta();
    } catch (err) {
      if (err.response.status == 400 || err.response.status == 500) {
        showToast(err.response || "Something went wrong, please try again later", "error");
      }
    } finally {
      setPageLoading(true);
    }
  };

  const fetch_ticket_deta = async () => {
    try {
      const res = await NodeaxiosInstance.get("/kitchen/my-membership-bookings",
        { headers: { Authorization: userData?.token } }
      );

      setMyMembership(prev => {
        const combined = [...prev, ...(res.data?.result || [])];

        // food bookings have booking_id instead of membership_purchase_id/id
        const keyOf = (t) => t.membership_purchase_id || t.booking_id || t.id;
        const unique = combined.filter(
          (item, index, self) =>
            index == self.findIndex(t => keyOf(t) == keyOf(item))
        );

        return unique;
      });


      setPageLoaded(true);
    } catch (err) {
      if (err.response.status == 400 || err.response.status == 500) {
        showToast(err.response || "Something went wrong, please try again later", "error");
      }
    }
  };

  useEffect(() => {
    getMyMembership();
  }, []);
  const handleCardClick = (vendorID, membershipID, PurchaseID) => {
    setSelectedCard({ vendorID, membershipID, PurchaseID });
  };


  return (
    <>
      <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
        <div className="d-flex justify-content-between align-items-center ms-2 me-2">
          <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => navigate(-1)} />
          <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
            My memberships
          </div>
        </div>
      </div>
      <div className="p-2 messengerList " >
        {myMembership &&
          <div className="ff-poppins-semiBold fs-20 ms-2 ps-1 secondary-text-1">
            Your Membership Cards
          </div>}
        <div className="scroller-style-y">
          <div style={{ marginBottom: "200px" }}>
            {
              pageLoading ?
                myMembership.length > 0 ? (
                  myMembership.map((membership, index) => (
                    <div key={index} >
                      {
                        membership?.membership_ticket_id ?
                          <div onClick={() => navigate(`/food-membership-detail/${membership.vendor_id}/${membership.membership_ticket_id}`, { state: { fromPage: 'mymembershiplist', booking_id: membership.booking_id }, })}>
                            <Kitchen_membership_card Data={membership} pageName='mymembershiplist' />
                          </div>
                          :
                          <div onClick={() => {
                            if (new Date(membership?.expiry_date) > new Date()) {
                              navigate("/MembershipBooking", {
                                state: {
                                  vendorId: membership.vendor_id, MembershipStatus:
                                    membership.membership_detail.category_status, membership_ID: membership.membership_purchase_id,
                                },
                              })
                            }
                          }}  >

                            <MembershipCard
                              buttonName="Subscription"
                              threeDot={
                                <BsThreeDots
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#offcanvasBottom"
                                  aria-controls="offcanvasBottom"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCardClick(
                                      membership?.vendor_detail.vendor_id,
                                      membership?.membership_detail.membership_id,
                                      membership?.membership_purchase_id);
                                  }} />
                              }
                              Status={membership?.expiry_date}
                              data={{
                                membershipDetails: membership.membership_detail,
                                VendorDetails: membership?.vendor_detail,
                              }}
                              // expiryDate={}
                              cardColor={membership?.membership_detail?.card_color_status ?
                                membership?.membership_detail.card_color :
                                membership?.membership_detail.card_pattern_image_url
                              }
                            />

                          </div>
                      }
                    </div>
                  ))
                ) :
                  <div className="mt-5">
                    <div className="mt-5">
                      <Lottie animationData={empotyLottie} />
                    </div>
                    <p className='text-dark text-center p-0 m-0 mt-5 ff-poppins-bold fs-16 '>No memberships available</p>
                  </div>
                :
                <div className="ReactLoading ">
                  <div className="spinner-border" role="status"  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>

            }
          </div>
        </div>

        <div
          class="offcanvas offcanvas-bottom mainModal"
          style={{
            position: "absolute !important",
            right: "initial", left: "initial", padding: '2%'
          }}
          tabindex="-1"
          id="offcanvasBottom"
          aria-labelledby="offcanvasBottomLabel"
        >
          <div className="">
            <div className="classExtentdMemberShip">
              <div></div>
              <div>
                <p className="m-0 ff-poppins-semiBold mb-3">Options</p>
              </div>
              <div>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
            </div>
            <div className="position-relative"></div>
            <p
              className="m-0 ff-poppins-regular"
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (
                  selectedCard.vendorID &&
                  selectedCard.membershipID &&
                  selectedCard.PurchaseID
                ) {
                  navigate("/BuyNow", {
                    state: {
                      vendorId: selectedCard.vendorID,
                      membership_ID: selectedCard.membershipID,
                      PurchaseID: selectedCard.PurchaseID,
                      flowParent: "extend",
                    },
                  });
                }
              }}
            >
              Extend Plan
            </p>
          </div>
        </div>


      </div>
    </>
  );
};
export default UserMembership;
